import { createAction, props } from '@ngrx/store';

export const setCampaign = createAction('Campaign', props<{ campaignId: string }>());
